import { PropTypes } from "prop-types"

export function ModalFooter({ children }) {
  return <div className="oj-modal-footer">{children}</div>
}

ModalFooter.propTypes = {
  children: PropTypes.node
}

export default ModalFooter
